/**
 * Subscribe Button Frontend Handler
 */

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.xtra-subscribe-button');
    
    // Store original button texts
    const buttonStates = new Map();
    
    buttons.forEach(button => {
        // Store the original text for each button
        buttonStates.set(button, button.textContent);
        
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            
            const messageDiv = button.parentElement.querySelector('.xtra-subscribe-message');
            const originalText = buttonStates.get(button);
            
            // Show loading state
            button.disabled = true;
            button.textContent = 'Processing...';
            messageDiv.style.display = 'none';
            messageDiv.className = 'xtra-subscribe-message';
            
            // Get data from attributes
            const priceId = button.dataset.priceId || '';
            const successUrl = button.dataset.successUrl || '';
            const cancelUrl = button.dataset.cancelUrl || '';
            
            try {
                // Make request to create checkout session
                const response = await fetch(xtraStripeSubscribe.apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': xtraStripeSubscribe.nonce
                    },
                    body: JSON.stringify({
                        price_id: priceId,
                        success_url: successUrl,
                        cancel_url: cancelUrl
                    })
                });
                
                const data = await response.json();
                
                if (response.ok && data.url) {
                    // Redirect to Stripe checkout
                    window.location.href = data.url;
                } else {
                    // Show error message
                    const errorMessage = data.message || 'Failed to create checkout session. Please try again.';
                    messageDiv.textContent = errorMessage;
                    messageDiv.className = 'xtra-subscribe-message error';
                    messageDiv.style.display = 'block';
                    
                    // Reset button
                    button.disabled = false;
                    button.textContent = originalText;
                }
            } catch (error) {
                // Show network error
                messageDiv.textContent = 'Network error. Please check your connection and try again.';
                messageDiv.className = 'xtra-subscribe-message error';
                messageDiv.style.display = 'block';
                
                // Reset button
                button.disabled = false;
                button.textContent = originalText;
            }
        });
    });
    
    // Reset button states when user navigates back or page becomes visible
    const resetButtons = () => {
        buttons.forEach(button => {
            if (button.textContent === 'Processing...' && button.disabled) {
                const originalText = buttonStates.get(button);
                const messageDiv = button.parentElement.querySelector('.xtra-subscribe-message');
                
                // Reset button to original state
                button.disabled = false;
                button.textContent = originalText;
                
                // Hide any error messages
                if (messageDiv) {
                    messageDiv.style.display = 'none';
                }
            }
        });
    };
    
    // Listen for back/forward navigation
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            // Page was restored from cache (back/forward navigation)
            resetButtons();
        }
    });
    
    // Listen for tab visibility changes
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            // Page became visible again
            resetButtons();
        }
    });
});
